<template>
  <div id="login-container" :class="webnamefinal">
    <Navigationbar v-if="!isInIframe" :webname="webnamefinal"> </Navigationbar>
    <b-loading
      v-if="isLoading"
      :is-full-page="true"
      :active="isLoading"
    ></b-loading>
    <div id="content-frame" v-else>
      <div id="content-logo">
        <img :src="logourl" class="top-logo" />
      </div>
      <div id="login-step1" class="">
        <div id="main-part">
          <div id="content-inner">
            <template v-if="validToken">
              <div class="register-header">
                <div></div>
                <h2>Reiniciar contraseña</h2>
                <div></div>
              </div>
              <div class="register-content">
                <p
                  v-html="
                    getText(
                      'aux.changepwd.reset',
                      'Escribe aquí tu nueva contraseña:'
                    )
                  "
                  class="primary-text"
                ></p>
                <b-field :type="type_password" class="">
                  <b-input
                    @keydown.native.enter="handleEnterKey"
                    @input="ifFormValid"
                    ref="passwordField"
                    type="password"
                    class="onlyline"
                    placeholder="Contraseña"
                    v-model="inputs.password"
                    required
                    expanded
                    password-reveal
                  >
                  </b-input>
                </b-field>
                <b-field :type="type_password" :message="msg_password" class="">
                  <b-input
                    @keydown.native.enter="handleEnterKey"
                    @input="ifFormValid"
                    ref="passwordField2"
                    type="password"
                    class="onlyline"
                    placeholder="Escribe de nuevo la contraseña"
                    v-model="inputs.password2"
                    required
                    expanded
                    password-reveal
                  >
                  </b-input>
                </b-field>
              </div>
              <div class="login-button-container">
                <a
                  @click="submitPassword()"
                  class="button is-medium is-fullwidth is-primary"
                  :class="classLoading"
                >
                  <span> Cambiar contraseña </span>
                </a>
              </div>
            </template>
            <template v-else>
              <div class="register-header">
                <div></div>
                <h2>Error reiniciando contraseña</h2>
                <div></div>
              </div>
              <div class="register-content">
                <p v-html="this.errormsg" class="primary-text"></p>
                <router-link to="resetpassword" class="is-size-5  ">
                  Solicitar reenvío de contraseña
                </router-link>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <Footerbar v-if="!isInIframe && isLoading == false"> </Footerbar>
  </div>
</template>
<script>
//import { mapState } from 'vuex'
import Navigationbar from '@/components/UI/Navigationbar.vue'
import Footerbar from '@/components/UI/Footerbar.vue'
import { RegisterStepMixin } from '@/components/mixins/RegisterStepMixin'
import { ToolsMixin } from '@/components/mixins/ToolsMixin'
export default {
  name: 'ResetPassword',
  components: {
    Navigationbar,
    Footerbar
  },
  props: {
    webname: {
      type: String,
      default: ''
    },
    env: {
      type: String,
      default: 'PRO'
    },
    token: {
      type: String,
      default: ''
    }
  },
  mixins: [RegisterStepMixin, ToolsMixin],

  data: () => ({
    inputs: {
      password: '',
      password2: ''
    },
    msg_password: '',
    type_password: '',
    isLoading: true
  }),
  methods: {
    submitPassword() {
      this.isLoading = true
      if (this.ifFormValid() == false) {
        this.isLoading = false
        return
      } else {
        this.isLoading = false
      }
      // this.$store
      //   .dispatch('auth/resetPassword', email)
      //   .then(() => {
      //     this.done = true
      //     this.isLoading = false
      //   })
      //   .catch(error => {
      //     console.log(error.response)
      //     this.isLoading = false
      //     this.type_email = 'is-danger'
      //     this.msg_email = error.response.data[0]
      //   })

      //this.$parent.close()
    },
    ifFormValid() {
      let are_equals = this.inputs.password === this.inputs.password2
      let min_length =
        this.inputs.password.length > 8 && this.inputs.password.length > 7
      if (!min_length) {
        this.msg_password = 'La longitud es demasiado corta'
        this.type_password = 'is-danger'
      } else if (!are_equals) {
        this.msg_password = 'Las dos contraseñas no coinciden'
        this.type_password = 'is-danger'
      } else {
        this.msg_password = ''
        this.type_password = ''
        return are_equals && min_length
      }
    }

    /*handleEnterKey() {
      this.resetPassword(this.inputs)
      this.$refs.emailField.$el.firstElementChild.blur()
    }*/
  },
  computed: {
    logourl: function() {
      return process.env.BASE_URL + this.webnamefinal + '/logo.png'
    },
    errormsg: function() {
      if (this.validToken == false)
        return this.getText(
          'aux.changepwd.tokenError',
          'El enlace no es valido. Vuelve a solicitar el reenvío de tu contraseña'
        )
      else return ''
    },

    classLoading: function() {
      if (this.isLoading == true) return 'is-loading'
      else return ''
    },
    isInIframe: function() {
      return window.location != window.parent.location ? true : false
    },
    validToken: function() {
      let t_length = this.token.length > 8 ? true : false
      let t_valid = true
      return t_length && t_valid
    }
  },
  created() {
    console.log('on created')
    this.retrieveConfigFilesAndInit().finally(() => {
      // dispatch function to check code
    })
  }
}
</script>
<style lang="css">
/* only if it is embeded within the home */
</style>
